export const DROPPABLE_ID_AREA = 'droppable'

export const FORMAT_YEAR_MONTH_DAY = 'YYYY-MM-DD'
export const FORMAT_YEAR_MONTH_DAY_WITH_TIME = 'YYYY-MM-DD HH:mm'
export const FORMAT_DAY_MONTH_YEAR_HOUR_MIN = 'DD/MM/YYYY HH:mm'
